import { Component, OnInit } from '@angular/core';
import { AuthAPIService } from '../auth/auth.api.service';
import { SwalUtils } from '../utils/swal.utils';

@Component({
  selector: 'app-archived',
  template: '',
})
export class ArchivedComponent implements OnInit {

  constructor(
    private authService: AuthAPIService,
    private swalUtils: SwalUtils
  ) { }

  ngOnInit() {
    this.swalUtils.displayWarning({
      title: 'Your account is archived',
      text: 'Contact your manager to find out more'
    }).then(() => {
      this.authService.logout();
    });
  }
}
